/* eslint-env browser */
const types = ['secondary', 'tertiary', 'alert', 'warning'];

export const getType = (props) =>
  types.filter((item) => props[item])[0] || 'normal';

export const addPopoverPortalLayer = () => {
  /*
  This makes sure the popover appears over everything.
  If we put the popover into a portal it will always appear in front
  regardless of the stacking order of he other elements in the DOM tree.
   */
  const popoverLayer = document.createElement('div');
  popoverLayer.id = 'dbk-popover-layer';
  popoverLayer.style.position = 'absolute';
  popoverLayer.style.top = '0px';
  popoverLayer.style.left = '0px';
  popoverLayer.style.width = '100%';
  // Might want to co ordinate z-indexes with other z-indexes in the repo?
  popoverLayer.style['z-index'] = 10000;
  document.body.appendChild(popoverLayer);
  return popoverLayer;
};

export const normaliseSVGpoint = (n, offset = 0.5) => Math.floor(n) + offset;
